module.exports = __webpack_public_path__ + "img/com.codeway.couplesapp.82bbd33e.png";